/* Aloha Palms - rush fee note under the delivery date picker (cart page + cart drawer).
   Food items: 20% of EACH eligible item's own price (dry box excluded), rounded to nearest $5, per unit.
   Keepsake surfboards / mouse keepsake, leis, haku crowns, hair clips: flat $15 each.
   Add-ons, dry boxes, delivery, tips, gift wrap, cards etc. never count. */
(function () {
  var PHONE_SMS = 'sms:+18087525317';
  var PHONE_LABEL = '(808) 752-5317';
  var CONTACT_URL = '/pages/contact';
  var FLAT_FEE = 15;
  var FOOD_RATE = 0.2;

  var FOOD_HANDLES = [
    'classic-charcuterie-board-best-seller',
    'hand-delivered-charcuterie-board-nut-free',
    'hand-delivered-charcuterie-board-vegan',
    'hand-delivered-charcuterie-board-gluten-free',
    'custom-charcuterie-board-multiple-dietary-restrictions-accommodated',
    'charcuterie-platter-board-or-box',
    'heart-shaped-charcuterie-board',
    'fresh-fruit-platters',
    'fresh-fruit-cakes',
    'classic-christmas-holiday-boards',
    'christmas-tree-board-bundle',
    '3d-christmas-tree-cone',
    'thanksgiving-charcuterie-boards-pre-order',
    'halloween-spooktacular-charcuterie-boards',
    'baby-shower-oh-baby-baptism-charcuterie-board',
    'limited-edition-valentine-s-heart-charcuterie-board',
    'letter-number-celebration-boards'
  ];
  var FLAT_HANDLES = [
    'engraved-keepsake-surfboard',
    'lilo-stitch-inspired-engraved-surfboard',
    'mouse-shaped-wooden-keepsake',
    'plumeria-lei',
    'haku-lei-flower-crown',
    'hand-delivered-fresh-flower-hair-accessories-in-oahu-hawaii-aloha-palms-hospitality'
  ];

  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function isDryOption(name) { return /dry/i.test(name || ''); }
  function isNoDry(value) { return /^\s*no\b/i.test(value || ''); }

  // Price of the item WITHOUT the dry box (in dollars). Falls back to the line's own unit price.
  function basePrice(item) {
    var fallback = (item.original_price || item.price || 0) / 100;
    return getProduct(item.handle).then(function (p) {
      if (!p || !p.variants || !p.options) return fallback;
      var dryIdx = -1;
      p.options.forEach(function (o, i) {
        var name = typeof o === 'string' ? o : o.name;
        if (isDryOption(name)) dryIdx = i;
      });
      if (dryIdx === -1) return fallback;
      var v = p.variants.filter(function (x) { return x.id === item.variant_id; })[0];
      if (!v) return fallback;
      var opts = v.options || [v.option1, v.option2, v.option3];
      if (isNoDry(opts[dryIdx])) return v.price / 100;
      var match = p.variants.filter(function (x) {
        var xo = x.options || [x.option1, x.option2, x.option3];
        for (var i = 0; i < opts.length; i++) {
          if (i === dryIdx) { if (!isNoDry(xo[i])) return false; }
          else if (xo[i] !== opts[i]) return false;
        }
        return true;
      })[0];
      return match ? match.price / 100 : fallback;
    });
  }

  function itemFee(item) {
    var handle = item.handle || '';
    var type = (item.product_type || '').toLowerCase();
    var qty = item.quantity || 1;
    if (FOOD_HANDLES.indexOf(handle) !== -1) {
      return basePrice(item).then(function (price) {
        return Math.round(price * FOOD_RATE / 5) * 5 * qty;
      });
    }
    if (FLAT_HANDLES.indexOf(handle) !== -1 || type === 'leis') {
      return Promise.resolve(FLAT_FEE * qty);
    }
    return Promise.resolve(0);
  }

  function rushFee(cart) {
    return Promise.all((cart.items || []).map(itemFee)).then(function (fees) {
      return fees.reduce(function (a, b) { return a + b; }, 0);
    });
  }

  var lastFee = null;

  function noteHtml(fee) {
    return (
      '<p class="ap-rush-note__title">Need it sooner, or is your date greyed out?</p>' +
      '<p>Rush orders are often possible &mdash; just check with us first.</p>' +
      '<p class="ap-rush-note__fee">Rush fee for this order: <strong>$' + fee + '</strong></p>' +
      '<p class="ap-rush-note__small">20% of each board, platter or cake (rounded to the nearest $5); $15 per keepsake surfboard, lei or hair clip.</p>' +
      '<p>Text <a href="' + PHONE_SMS + '">' + PHONE_LABEL + '</a> or ' +
      '<a href="' + CONTACT_URL + '">send us a message</a> to check availability.</p>'
    );
  }

  function render() {
    var widgets = document.querySelectorAll('pickeasy-app-widget');
    widgets.forEach(function (widget) {
      var note = null;
      for (var c = widget.parentNode.firstElementChild; c; c = c.nextElementSibling) {
        if (c.classList && c.classList.contains('ap-rush-note')) { note = c; break; }
      }
      if (!note) {
        note = document.createElement('div');
        note.className = 'ap-rush-note';
        widget.parentNode.insertBefore(note, widget.nextSibling);
      }
      if (!lastFee) {
        note.style.display = 'none';
      } else {
        note.style.display = '';
        var html = noteHtml(lastFee);
        if (note.getAttribute('data-ap-html') !== html) { note.innerHTML = html; note.setAttribute('data-ap-html', html); }
      }
    });
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(rushFee)
      .then(function (fee) { lastFee = fee; render(); })
      .catch(function () {});
  }

  // Recalculate whenever the theme changes the cart.
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 300); }).catch(function () {});
    }
    return p;
  };

  // Re-insert the note if the cart drawer or date picker re-renders.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; render(); }, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });

  var style = document.createElement('style');
  style.textContent =
    '.ap-rush-note{margin:12px 0;padding:12px 14px;border:1px solid #2b5d73;border-radius:8px;' +
    'background:#f2f8f9;color:#1d3540;text-align:left;font-size:14px;line-height:1.45}' +
    '.ap-rush-note p{margin:0 0 4px}.ap-rush-note p:last-child{margin:0}' +
    '.ap-rush-note__title{font-weight:600}.ap-rush-note__fee{color:#2b5d73}' +
    '.ap-rush-note__small{font-size:12px;color:#4a6470}' +
    '.ap-rush-note a{color:#2b5d73;text-decoration:underline}';
  document.head.appendChild(style);

  window.apRushFee = rushFee; // used for testing

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
